import React, { useEffect, useState } from "react";
import { Box, Backdrop, CircularProgress } from "@mui/material";
import { SnackbarProvider } from "notistack";
import { Routes, Route, useLocation, Navigate } from "react-router-dom"; // For routing
import { useAuth } from "./context/AuthContext"; // Auth hook
import Navbar from "./components/Navbar"; // Your Navbar
import Header from "./components/common/Header"; // Your Header
import MessagingAccountHealthBanner from "./components/common/MessagingAccountHealthBanner";
import Message from "./components/Message"; // Your Message component
import Upload from "./components/Upload"; // Your Upload component
import SendWhatsapp from "./components/SendWhatsapp"; // Your SendWhatsapp component
import Profile from "./components/common/Profile"; // Your Profile component
import CreditsInfoPage from "./components/common/CreditsInfoPage";
import TemplatesType1 from "./components/TemplatesType1"; // Your TemplatesType1 component
import PersonalWhatsapp from "./components/PersonalWhatsapp"; // Your PersonalWhatsapp component
import MessageQueue from "./components/personalWAComponent/MessageQueue"; // Your MessageQueue component
import GroupAdd from "./components/personalWAComponent/GroupAdd"; // Your GroupAdd component
import Login from "./components/Login"; // Your Login component
import EmailQueue from "./components/Email/EmailQueue"; // Your EmailQueue component
import EmailSchedule from "./components/Email/EmailSchedule"; // Your EmailSchedule component
import EmailAnalytics from "./components/Email/EmailAnalytics"; // Your EmailAnalytics component
import PostEmailView from "./components/Email/PostEmailView"; // Your PostEmailView component
import PersonalWhatsappAnalytics from "./components/personalWAComponent/PersonalWhatsappAnalytics";
import CreateTemplate from "./components/personalWAComponent/CreateTemplate";
import CreateEmailTemplate from "./components/Email/CreateEmailTemplate";
import EmailTemplateEditor from "./components/Email/EmailTemplateEditor";
import EmailTemplateList from "./components/Email/EmailTemplateList";
import ManageEmailSenders from "./components/Email/ManageEmailSenders";
import ManageDomains from "./components/Email/ManageDomains";
import DummyTemplateList from "./components/Email/DummyTemplateList";
import CreateNewTemplate from "./components/Email/CreateNewTemplate";
import AdminLayout from "./components/Admin/AdminLayout";
import AdminOverview from "./components/Admin/AdminOverview";
import AdminUserList from "./components/Admin/AdminUserList";
import AdminSubscriptions from "./components/Admin/AdminSubscriptions";
import AdminServiceHealth from "./components/Admin/AdminServiceHealth";
import AdminUserServiceLayout from "./components/Admin/AdminUserServiceLayout";
import AdminUserProfilePage from "./components/Admin/services/AdminUserProfilePage";
import AdminPersonalWhatsappPage from "./components/Admin/services/AdminPersonalWhatsappPage";
import AdminEmailServicePage from "./components/Admin/services/AdminEmailServicePage";
import AdminAwsSesAccountsPage from "./components/Admin/services/AdminAwsSesAccountsPage";
import AdminWhatsappBusinessPage from "./components/Admin/services/AdminWhatsappBusinessPage";
import Cookie from "js-cookie";
import { BillingProvider } from "./context/BillingContext";
import CreditWalletPage from "./components/billing/CreditWalletPage";
import CreditLedgerPage from "./components/billing/CreditLedgerPage";
import CreditTopupsPage from "./components/billing/CreditTopupsPage";
import AdminCreditRatesPage from "./components/Admin/AdminCreditRatesPage";
import AdminUserBillingPage from "./components/Admin/services/AdminUserBillingPage";
import EmailMessageSpeedChart from "./components/Email/EmailMessageSpeed.js";
import WhatsappMessageSpeedChart from "./components/WhatsappMessageSpeed";
import CreateWhatsappTemplate from "./components/personalWAComponent/CreateWhatsappTemplate.js";
import EditWhatsappTemplate from "./components/personalWAComponent/EditWhatsappTemplate.js";
// WhatsApp Business Components
import WhatsappBusinessDashboard from "./components/whatsappBusiness/WhatsappBusinessDashboard";
import BusinessAccounts from "./components/whatsappBusiness/BusinessAccounts";
import PhoneNumbers from "./components/whatsappBusiness/PhoneNumbers";
import Templates from "./components/whatsappBusiness/Templates";
import SendMessage from "./components/whatsappBusiness/SendMessage";
import MediaManagement from "./components/whatsappBusiness/MediaManagement";
import BusinessProfile from "./components/whatsappBusiness/BusinessProfile";
import MessagingLimits from "./components/whatsappBusiness/MessagingLimits";
import CreateEditWhatsappBusinessTemplate from "./components/whatsappBusiness/CreateEditWhatsappBusinessTemplate";
import WhatsappCampaign from "./components/whatsappBusiness/WhatsappCampaign";
import WhatsappBusinessMessageSpeed from "./components/whatsappBusiness/WhatsappBusinessMessageSpeed";
import WhatsappBusinessGroupAdd from "./components/whatsappBusiness/groups/WhatsappBusinessGroupAdd";
import WhatsappBusinessGroupsManage from "./components/whatsappBusiness/groups/WhatsappBusinessGroupsManage";
import WhatsappBusinessGroupContactsView from "./components/whatsappBusiness/groups/WhatsappBusinessGroupContactsView";
import TestMessage from "./components/whatsappBusiness/TestMessage";
import TemplateDetails from "./components/whatsappBusiness/TemplateDetails";
import WhatsappBusinessMessageQueue from "./components/whatsappBusiness/MessageQueue";
import Contacts from "./components/whatsappBusiness/Contacts";
import WhatsappChatbot from "./components/whatsappBusiness/WhatsappChatbot";
import UserManagement from "./components/UserManagement/UserManagement";
import ResetPassword from "./components/common/ResetPassword";
import FullScreenChatWindow from "./components/whatsappBusiness/FullScreenChatWindow";
import ContactChatWindow from "./components/whatsappBusiness/ContactChatWindow";
import WhatsappBusinessAdminDashboard from "./components/whatsappBusiness/admin/WhatsappBusinessAdminDashboard";
import CampaignManagement from "./components/whatsappBusiness/campaignManagement/CampaignManagement";
import BotTraining from "./components/whatsappBusiness/botTraining/BotTraining";
import WhatsappBusinessSettings from "./components/whatsappBusiness/WhatsappBusinessSettings";
import CommandCenterDashboard from "./components/whatsappBusiness/admin/CommandCenterDashboard";
import EmbeddedSignup from "./components/whatsappBusiness/EmbeddedSignup";
// CRM Components
import CRMDashboard from "./components/CRM/dashboard/CRMDashboard";
import CRMAnalytics from "./components/CRM/analytics/CRMAnalytics";
import CRMPipeline from "./components/CRM/pipeline/CRMPipeline";
import CRMDealDetail from "./components/CRM/pipeline/CRMDealDetail";
import CRMContacts from "./components/CRM/contacts/CRMContacts";
import CRMContactDetail from "./components/CRM/contacts/CRMContactDetail";
import CRMActivity from "./components/CRM/activity/CRMActivity";
import CRMPipelineStages from "./components/CRM/pipeline/CRMPipelineStages";
import CRMContactTags from "./components/CRM/contacts/CRMContactTags";
import CRMProductsServices from "./components/CRM/products/CRMProductsServices";

const AppContent = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const { isLoggedIn, checkAuthStatus, authChecked } = useAuth();
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const isFullScreenChat = location.pathname.startsWith("/whatsapp-business/chat-window");
    const isAdminPortal = location.pathname.startsWith("/admin/vspp/9403/ktl/dashboard");
    const isPlatformAdmin = (() => {
        const roles = (Cookie.get("userRole") || "").split(",").map((r) => r.trim());
        return roles.includes("ADMIN#VI295") || roles.includes(";ADMIN#VI295");
    })();

    // useEffect(() => {
    //     const checkingAuth = () => {
    //         setLoading(true);
    //         checkAuthStatus();
    //         setTimeout(() => {
    //             setLoading(false);
    //         }, 1200);
    //     };
    //     checkingAuth();
    // }, [checkAuthStatus]);

    useEffect(() => {
        checkAuthStatus();
    }, [checkAuthStatus]);

    if (!authChecked) {
        return (
            <Backdrop
                sx={(theme) => ({
                    color: "#fff",
                    zIndex: theme.zIndex.drawer + 1,
                })}
                open
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        );
    }

    return (
        <BillingProvider>
        <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            preventDuplicate
        >
            <>
                {/* {loading && (
                    <Box
                        sx={{ width: "100%", height: "100vh", display: "flex" }}
                    >
                        <Backdrop
                            sx={(theme) => ({
                                color: "#fff",
                                zIndex: theme.zIndex.drawer + 1,
                            })}
                            open={loading}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                    </Box>
                )} */}

                {/* {!loading && ( */}
                <>
                    {!isLoggedIn ? (
                        <Login /> // Render Login if not logged in
                    ) : (
                        <>
                            {isFullScreenChat ? (
                                // Full-screen chat windows - no navbar/header
                                <Routes>
                                    <Route
                                        path="/whatsapp-business/chat-window"
                                        element={<FullScreenChatWindow />}
                                    />
                                    <Route
                                        path="/whatsapp-business/chat-window/contact/:phoneNumber"
                                        element={<ContactChatWindow />}
                                    />
                                </Routes>
                            ) : isAdminPortal && isPlatformAdmin ? (
                                <Routes>
                                    <Route path="/admin/vspp/9403/ktl/dashboard" element={<AdminLayout />}>
                                        <Route index element={<AdminOverview />} />
                                        <Route path="personal" element={<AdminUserList section="personal" />} />
                                        <Route path="email" element={<AdminUserList section="email" />} />
                                        <Route path="aws-ses-accounts" element={<AdminAwsSesAccountsPage />} />
                                        <Route path="whatsapp-business" element={<AdminUserList section="whatsapp-business" />} />
                                        <Route path="all-users" element={<AdminUserList section="all" />} />
                                        <Route path="subscriptions" element={<AdminSubscriptions />} />
                                        <Route path="credit-rates" element={<AdminCreditRatesPage />} />
                                        <Route path="service-health" element={<AdminServiceHealth />} />
                                        <Route path="users/:userId" element={<AdminUserServiceLayout />}>
                                            <Route path="profile" element={<AdminUserProfilePage />} />
                                            <Route path="personal-whatsapp" element={<AdminPersonalWhatsappPage />} />
                                            <Route path="email" element={<AdminEmailServicePage />} />
                                            <Route path="whatsapp-business" element={<AdminWhatsappBusinessPage />} />
                                            <Route path="billing" element={<AdminUserBillingPage />} />
                                        </Route>
                                    </Route>
                                </Routes>
                            ) : (
                                // Regular routes with navbar and header
                                <Navbar
                                    sidebarOpen={sidebarOpen}
                                    setSidebarOpen={setSidebarOpen}
                                >
                                    <Box sx={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0, minHeight: 0 }}>
                                        <Header sidebarOpen={sidebarOpen} currentPath={location.pathname} />
                                        <MessagingAccountHealthBanner />
                                        <Box sx={{ flex: 1, minHeight: 0, padding: "0rem 1rem 1rem 1rem", overflowY: "auto", overflowX: "hidden", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}>
                                            <Routes>
                                    {/* Define your routes */}
                                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                                    <Route path="/dashboard" element={<CommandCenterDashboard />} />
                                    <Route
                                        path="/upload"
                                        element={<Upload />}
                                    />
                                    <Route
                                        path="/send-whatsapp"
                                        element={<SendWhatsapp />}
                                    />
                                    <Route
                                        path="/profile"
                                        element={<Profile />}
                                    />
                                    <Route
                                        path="/credits-info"
                                        element={<CreditsInfoPage />}
                                    />
                                    <Route path="/billing" element={<CreditWalletPage />} />
                                    <Route path="/billing/ledger" element={<CreditLedgerPage />} />
                                    <Route path="/billing/topups" element={<CreditTopupsPage />} />
                                    <Route
                                        path="/change-password"
                                        element={<ResetPassword />}
                                    />
                                    <Route
                                        path="/create-template"
                                        element={<CreateTemplate />}
                                    />
                                    <Route
                                        path="/create-whatsapp-template"
                                        element={<CreateWhatsappTemplate />}
                                    />
                                     <Route
                                        path="/edit-whatsapp-template"
                                        element={<EditWhatsappTemplate />}
                                    />
                                    <Route
                                        path="/template-type1"
                                        element={<TemplatesType1 />}
                                    />
                                    <Route
                                        path="/personal-whatsapp"
                                        element={<PersonalWhatsapp />}
                                    />
                                    <Route
                                        path="/message-queue"
                                        element={<MessageQueue />}
                                    />
                                    <Route 
                                        path="/whatsapp/message-speed"
                                        element={<WhatsappMessageSpeedChart/>}
                                    />

                                    <Route 
                                        path="/email/message-speed"
                                        element={<EmailMessageSpeedChart/>}
                                    />

                                    
                                    <Route
                                        path="/group-add"
                                        element={<GroupAdd />}
                                    />
                                    <Route
                                        path="/email-queue"
                                        element={<EmailQueue />}
                                    />
                                    <Route path="/email/templates" element={<EmailTemplateList />} />
                                     <Route path="/email/templates/create" element={<EmailTemplateEditor />} />
                                    <Route
                                        path="/email/manageemailsenders"
                                        element={<ManageEmailSenders />}
                                    />
                                    <Route
                                        path="/email/managedomains"
                                        element={<ManageDomains />}
                                    />
                                    
                                    <Route
                                        path="/email/templateList"
                                        element={<DummyTemplateList />}
                                    />
                                    <Route
                                        path="/email/CreateNewTemplate"
                                        element={<CreateNewTemplate />}
                                    />

                                    <Route
                                        path="/email-schedule"
                                        element={<EmailSchedule />}
                                    />
                                    <Route
                                        path="/email-analytics"
                                        element={<EmailAnalytics />}
                                    />
                                    <Route
                                        path="/email/:userId/:id"
                                        element={<PostEmailView />}
                                    />
                                    <Route
                                        path="/personal/whatsapp/report"
                                        element={<PersonalWhatsappAnalytics />}
                                    />
                                    {/* Dynamic route */}
                                          <Route path="/templates" element={<EmailTemplateList />} />
      <Route path="/templates/create" element={<EmailTemplateEditor />} />
      <Route path="/templates/edit/:id" element={<EmailTemplateEditor />} />
      <Route path="/templates/view/:id" element={<EmailTemplateEditor viewOnly />} />

       {/* WhatsApp Business Admin Dashboard routes */}
     { (Cookie.get('userRole') === 'ADMIN#VI295' || Cookie.get('userRole') === ';ADMIN#VI295') &&  <Route path="/whatsapp-business/admin" element={<WhatsappBusinessAdminDashboard />} /> }

       {/* WhatsApp Business routes */}
       <Route path="/whatsapp-business" element={<WhatsappBusinessDashboard />} />
       <Route path="/whatsapp-business/accounts" element={<BusinessAccounts />} />
       <Route path="/whatsapp-business/phone-numbers" element={<PhoneNumbers />} />
       <Route path="/whatsapp-business/templates" element={<Templates />} />
       <Route path="/whatsapp-business/templates/create" element={<CreateEditWhatsappBusinessTemplate />} />
       <Route path="/whatsapp-business/templates/edit" element={<CreateEditWhatsappBusinessTemplate />} />
       <Route path="/whatsapp-business/template/:templateid" element={<TemplateDetails />} />
       <Route path="/whatsapp-business/send-message" element={<SendMessage />} />
       <Route path="/whatsapp-business/message-queue" element={<WhatsappBusinessMessageQueue />} />
       <Route path="/whatsapp-business/campaign" element={<WhatsappCampaign />} />
       <Route path="/whatsapp-business/campaign-management" element={<CampaignManagement />} />
       <Route path="/whatsapp-business/test-message" element={<TestMessage />} />
       <Route path="/whatsapp-business/message-speed" element={<WhatsappBusinessMessageSpeed />} />
                            <Route path="/whatsapp-business/groups" element={<WhatsappBusinessGroupsManage />} />
                            <Route path="/whatsapp-business/groups/:groupName/contacts" element={<WhatsappBusinessGroupContactsView />} />
                            <Route path="/whatsapp-business/contacts" element={<Contacts />} />
       <Route path="/whatsapp-business/media" element={<MediaManagement />} />
       <Route path="/whatsapp-business/profile" element={<BusinessProfile />} />
       <Route path="/whatsapp-business/limits" element={<MessagingLimits />} />
       <Route path="/whatsapp-business/chatbot" element={<WhatsappChatbot />} />
       <Route path="/whatsapp-business/bot-training" element={<BotTraining />} />
       <Route path="/whatsapp-business/settings" element={<WhatsappBusinessSettings />} />
       {/* Embedded Signup (test route only - intentionally not linked in nav) */}
       <Route path="/whatsapp-business/embedded-signup" element={<EmbeddedSignup />} />
       <Route path="/user-management" element={<UserManagement />} />
       {/* CRM Routes */}
       <Route path="/crm/dashboard" element={<CRMDashboard />} />
       <Route path="/crm/analytics" element={<CRMAnalytics />} />
       <Route path="/crm/pipeline"  element={<CRMPipeline />} />
       <Route path="/crm/pipeline/:id"  element={<CRMDealDetail />} />
       <Route path="/crm/stages"    element={<CRMPipelineStages />} />
       <Route path="/crm/tags"      element={<CRMContactTags />} />
       <Route path="/crm/contacts/:contactId" element={<CRMContactDetail />} />
       <Route path="/crm/contacts"  element={<CRMContacts />} />
       <Route path="/crm/tasks"  element={<CRMActivity />} />
       <Route path="/crm/products-services" element={<CRMProductsServices />} />
                                            </Routes>
                                        </Box>
                                    </Box>
                                </Navbar>
                            )}
                        </>
                    )}
                </>
                {/* )} */}
            </>
        </SnackbarProvider>
        </BillingProvider>
    );
};

export default AppContent;
